import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// CRITICAL: Detect password recovery BEFORE Supabase client consumes the hash fragment.
// The Supabase JS client auto-processes #access_token=...&type=recovery and clears the hash,
// so lazy-loaded components like Auth.tsx would never see it.
(() => {
  const hash = window.location.hash;
  const search = window.location.search;
  if (
    hash.includes("type=recovery") ||
    search.includes("type=recovery") ||
    search.includes("mode=reset")
  ) {
    sessionStorage.setItem("sb-recovery-flow", "true");
  }
})();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
